export default "__VITE_ASSET__WhcKYLe0__"